import { render, staticRenderFns } from "./ObjectDefinitions.vue?vue&type=template&id=48b206d4&"
import script from "./ObjectDefinitions.vue?vue&type=script&lang=ts&"
export * from "./ObjectDefinitions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports